let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1a6L0")).then(() => parcelRequire('he8HI'));